import styled from "@emotion/styled";
import { fontMerriweather } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";
import { EntityLink } from "~/components/entity-link";

import { SeriesArticleOtherScmpSeriesItem } from "./item";

export const StyledEntityLink = styled(EntityLink)``;

export const StyledBaseLink = styled(BaseLink)`
  color: #ffffff;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
`;

export const SeriesArticleOtherScmpSeriesItemContainer = styled.div`
  flex-basis: 100%;

  margin-block-end: 20px;
  padding-inline: 12px 12px;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-basis: 50%;

    margin-block-end: 32px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-basis: 33.3%;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    flex-basis: 25%;
  }
`;

export const StyledSeriesArticleOtherScmpSeriesItem = styled(SeriesArticleOtherScmpSeriesItem)``;

export const Container = styled.div`
  padding-block: 40px 32px;

  background-color: #000000;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-inline: 12px;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-inline-size: 1560px;
  margin-block: 0;
  margin-inline: auto;
`;

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const OtherScmpSeries = styled.div`
  display: inline-block;

  margin-block-end: 40px;
  padding: 8px;

  color: #000000;
  font-weight: 900;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 25px;

  background-color: #ffca05;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 20px;
    line-height: 25px;
  }
`;
